import React, { useState, useEffect } from "react";
import { Col, Form, Input, Row, Select } from "antd";
import axios from "axios";

const { Option } = Select;

const StepTo = ({ form, formData, setFormData }) => {
  const [countries, setCountries] = useState([]);

  // Fetch country list from API
  useEffect(() => {
    console.log("Fetching formData Receiver: ", formData);
    const fetchCountries = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/referensi/country`
        );

        if (Array.isArray(response.data.data)) {
          setCountries(response.data.data);
        } else {
          setCountries([]);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, [formData]);

  // Set initial values from formData
  useEffect(() => {
    if (formData.receiver) {
      form.setFieldsValue({ receiver: formData.receiver });
    }
  }, [formData, form]);

  // Handle country change and update phone code
  const handleCountryChange = (value) => {
    const selectedCountry = countries.find((c) => c.countryName === value);
    const newPhoneCode = selectedCountry?.phoneCode || "";

    setFormData((prev) => ({
      ...prev,
      receiver: { ...prev.receiver, country: value, phoneCode: newPhoneCode },
    }));
  };

  // Handle general input change
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      receiver: { ...prev.receiver, [field]: value },
    }));
  };

  return (
    <Form form={form} layout="vertical">
      <Row gutter={[24, 16]} className="mt-5">
        <Col span={12}>
          <Form.Item
            label="Name"
            name={["receiver", "name"]}
            // rules={[{ required: true, message: "Name is required" }]}
          >
            <Input
              placeholder="Enter Full Name"
              onChange={(e) => handleInputChange("name", e.target.value)}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Company" name={["receiver", "company"]}>
            <Input
              placeholder="Enter Company Name"
              onChange={(e) => handleInputChange("company", e.target.value)}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[24, 16]}>
        <Col span={12}>
          <Form.Item
            label="Type of ID"
            name={["receiver", "typeIdentity"]}
            // rules={[{ required: true, message: "Name is required" }]}
          >
            <Select placeholder="Select Type of ID">
              <Option value="passport">Passport</Option>
              <Option value="npwp">Tax Number</Option>
              <Option value="KTP">National ID</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Identity Number"
            name={["receiver", "numberIdentity"]}
          >
            <Input
              placeholder="Enter Number Identity"
              onChange={(e) =>
                handleInputChange("numberIdentity", e.target.value)
              }
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[24, 16]}>
        <Col span={12}>
          <Form.Item label="Country/Territory" name={["receiver", "country"]}>
            <Select
              showSearch
              placeholder="Select Country"
              onChange={handleCountryChange}
              value={formData.receiver?.country || undefined}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {countries.map((country) => (
                <Option key={country.idCountry} value={country.countryName}>
                  {country.countryName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Postal Code" name={["receiver", "postalCode"]}>
            <Input
              placeholder="Enter postal code"
              onChange={(e) => handleInputChange("postalCode", e.target.value)}
            />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item label="Address" name={["receiver", "address"]}>
        <Input.TextArea
          placeholder="Enter full address"
          rows={3}
          maxLength={100}
          onChange={(e) => handleInputChange("address", e.target.value)}
        />
      </Form.Item>

      <Row gutter={[24, 16]}>
        <Col span={12}>
          <Form.Item label="City" name={["receiver", "city"]}>
            <Input
              placeholder="Enter city"
              onChange={(e) => handleInputChange("city", e.target.value)}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Province" name={["receiver", "province"]}>
            <Input
              placeholder="Enter province"
              onChange={(e) => handleInputChange("province", e.target.value)}
            />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        label="Email"
        name={["receiver", "email"]}
        rules={[
          { type: "email", message: "Invalid email address" },
          // { required: true, message: "Email is required" },
        ]}
      >
        <Input
          placeholder="Enter email"
          onChange={(e) => handleInputChange("email", e.target.value)}
        />
      </Form.Item>

      <Row gutter={[24, 16]}>
        <Col span={8}>
          <Form.Item label="Phone Type" name={["receiver", "phoneType"]}>
            <Select onChange={(value) => handleInputChange("phoneType", value)}>
              <Option value="Mobile">Mobile</Option>
              <Option value="Home">Home</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Code" name={["receiver", "phoneCode"]}>
            <Input
              placeholder="Phone Code"
              onChange={(e) => handleInputChange("phoneCode", e.target.value)}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Phone"
            name={["receiver", "phone"]}
            // rules={[
            //   {
            //     required: true,
            //     message: "Phone number is required",
            //   },
            // ]}
          >
            <Input
              placeholder="Enter phone number"
              onChange={(e) => handleInputChange("phone", e.target.value)}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default StepTo;
